import React from "react";
import { colors } from "../global";

const NotFound = () => {
  return (
    <main
      className="flex items-center justify-center px-6 py-12"
    >
      <div className="max-w-md w-full text-center">
        {/* 404 Icon */}
        <div className="mb-8">
          <i
            className="fas fa-exclamation-triangle text-8xl mb-4 animate-bounce"
            style={{ color: colors.accent }}
          ></i>
        </div>

        {/* 404 Text */}
        <h1
          className="text-8xl font-bold mb-4"
          style={{ color: colors.primary }}
        >
          404
        </h1>

        {/* Message */}
        <h2
          className="text-2xl font-semibold mb-3"
          style={{ color: colors.secondary }}
        >
          Oops! Page Not Found
        </h2>

        <p className="mb-8" style={{ color: colors.darkGray }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 bg-white font-medium px-6 py-3 rounded-lg border-2 transition-colors duration-200"
            style={{ color: colors.primary, borderColor: colors.primary }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colors.gray;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = colors.white;
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Go Back
          </button>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
